// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__39PfL","fileBtn":"File_fileBtn__1eMFt","closeBtn":"File_closeBtn__2lL_j","fileSelected":"File_fileSelected__1Q3u3","disabled":"File_disabled__R6euH"};